import React from 'react';

const TouristGuidesAgency = () => {
  return (
    <div className="min-h-screen bg-gradient-to-r from-yellow-200 via-orange-200 to-red-200 flex flex-col items-center justify-center">
      <h1 className="text-5xl font-extrabold text-gray-800 mb-8">وكالة المرشدين السياحيين</h1>
      <div className="w-full md:w-2/3 lg:w-1/2 p-8 bg-white rounded-lg shadow-xl">
        <h2 className="text-2xl font-semibold text-gray-700 mb-6">ابحث عن مرشدك المثالي</h2>
        <p className="text-gray-600 mb-4">شبكتنا من المرشدين السياحيين المحترفين والمعتمدين جاهزة لتوفير جولات مخصصة ومليئة بالمعلومات. سواء كنت تبحث عن جولات تاريخية أو رحلات طبيعية، لدينا المرشد المناسب لك.</p>
        <button className="inline-block bg-orange-500 text-white py-2 px-4 rounded hover:bg-orange-600 transition">
          استكشف مرشدينا
        </button>
      </div>
    </div>
  );
};

export default TouristGuidesAgency;
